<style lang="scss" scoped>
  #login-window {
    width: 400px;

    .logo {
      height: 110px;
    }
  }

  #created-by {
    position: absolute;
    bottom: 30px;
    left: 30px;
    color: #999;
  }

  .error-flash {
    background-color: #ffd5d8;
  }
</style>

<template>
  <div class="bg-light-grey full-height flex justify-center items-center border">
    <div id="login-window">
      <div class="card rounded sh2">
        <div class="p3 bg-light-blue center rounded">
          <img class="logo" src="/static/img/ui/copy_print_logo.svg" alt="MyOrder">
          <div class="mt2 uppercase fz16 text-dark-blue">Bestillingsportal</div>
        </div>
        <div class="p3 center">
          <div class="fz24 mb2">Logg inn</div>
          <div class="error-flash p2 mb2 rounded" v-if="errors.hasError('login')">{{ errors.getFirstError('login') }}
          </div>

          <form novalidate @submit.stop.prevent="login()">
            <md-input-container :class="{'md-input-invalid': errors.hasError('username')}">
              <label>Brukernavn</label>
              <md-input v-model="username"></md-input>
              <span class="md-error" v-if="errors.hasError('username')">{{ errors.getFirstError('username') }}</span>
            </md-input-container>
            <md-input-container md-has-password :class="{'md-input-invalid': errors.hasError('password')}">
              <label>Passord</label>
              <md-input v-model="password" type="password"></md-input>
              <span class="md-error" v-if="errors.hasError('password')">{{ errors.getFirstError('password') }}</span>
            </md-input-container>
            <md-button class="md-raised md-primary btn-block mb3" @click.native="login()" :disabled="state.is('authenticating')">
              <div v-if="state.is('authenticating')">
                Logger deg på...
              </div>
              <span v-else>Logg på</span>
            </md-button>
          </form>

          <div class="clearfix mt3">
            <div class="col col-6 left-align">
              <md-checkbox class="md-primary m0" v-model="remember">Husk meg</md-checkbox>
            </div>
            <div class="col col-6 right-align">
              <router-link to="/">Glemt passord?</router-link>
            </div>
          </div>

        </div>
      </div>
      <div class="center mt2">
        <router-link to="/" class="text-black">Administrasjonsportal</router-link>
      </div>
    </div>
    <div id="created-by">Tjenesten er levert av Frode Fjellberg AS</div>
  </div>
</template>

<script>
  import State from '@/js/helpers/state';
  import Errors from '@/js/helpers/errors';
  import apiAuth from '@/js/api/auth';

  export default {
    data() {
      return {
        state: new State(),
        errors: new Errors(),
        username: '',
        password: '',
        remember: true,
      };
    },

    mounted() {
      if (apiAuth.isAuthenticated()) {
        this.$router.push('/');
      }
    },

    methods: {
      login() {
        this.state.start('authenticating');

        apiAuth.authenticate({
          username: this.username,
          password: this.password,
          remember: this.remember,
        }).then(() => {
          if (this.$route.query.redirect !== undefined) {
            this.$router.push(this.$route.query.redirect);
          } else {
            this.$router.push('/');
          }
        }).catch((error) => {
          this.state.stop('authenticating');

          let errors = {};

          if (error.response.data.errors !== undefined) {
            errors = error.response.data.errors;
          }

          if (error.response.data.error !== 'validation_error') {
            errors.login = [error.response.data.message];
          }

          this.errors.setErrors(errors);
        }).then(() => {
          this.state.stop('authenticating');
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Login.vue?0fbac546